export function replaceLocaleCharacters(string: string) {
  return string
    .replace(/%C0/gi, 'À')
    .replace(/%C1/gi, 'Á')
    .replace(/%C2/gi, 'Â')
    .replace(/%C3/gi, 'Ã')
    .replace(/%C4/gi, 'Ä')
    .replace(/%C5/gi, 'Å')
    .replace(/%C6/gi, 'Æ')
    .replace(/%C7/gi, 'Ç')
    .replace(/%C8/gi, 'È')
    .replace(/%C9/gi, 'É')
    .replace(/%CA/gi, 'Ê')
    .replace(/%CB/gi, 'Ë')
    .replace(/%CC/gi, 'Ì')
    .replace(/%CD/gi, 'Í')
    .replace(/%CE/gi, 'Î')
    .replace(/%CF/gi, 'Ï')
    .replace(/%D0/gi, 'Ð')
    .replace(/%D1/gi, 'Ñ')
    .replace(/%D2/gi, 'Ò')
    .replace(/%D3/gi, 'Ó')
    .replace(/%D4/gi, 'Ô')
    .replace(/%D5/gi, 'Õ')
    .replace(/%D6/gi, 'Ö')
    .replace(/%D8/gi, 'Ø')
    .replace(/%D9/gi, 'Ù')
    .replace(/%DA/gi, 'Ú')
    .replace(/%DB/gi, 'Û')
    .replace(/%DC/gi, 'Ü')
    .replace(/%DD/gi, 'Ý')
    .replace(/%DE/gi, 'Þ')
    .replace(/%DF/gi, 'ß')
    .replace(/%E0/gi, 'à')
    .replace(/%E1/gi, 'á')
    .replace(/%E2/gi, 'â')
    .replace(/%E3/gi, 'ã')
    .replace(/%E4/gi, 'ä')
    .replace(/%E5/gi, 'å')
    .replace(/%E6/gi, 'æ')
    .replace(/%E7/gi, 'ç')
    .replace(/%E8/gi, 'è')
    .replace(/%E9/gi, 'é')
    .replace(/%EA/gi, 'ê')
    .replace(/%EB/gi, 'ë')
    .replace(/%EC/gi, 'ì')
    .replace(/%ED/gi, 'í')
    .replace(/%EE/gi, 'î')
    .replace(/%EF/gi, 'ï')
    .replace(/%F0/gi, 'ð')
    .replace(/%F1/gi, 'ñ')
    .replace(/%F2/gi, 'ò')
    .replace(/%F3/gi, 'ó')
    .replace(/%F4/gi, 'ô')
    .replace(/%F5/gi, 'õ')
    .replace(/%F6/gi, 'ö')
    .replace(/%F7/gi, '÷')
    .replace(/%F8/gi, 'ø')
    .replace(/%F9/gi, 'ù')
    .replace(/%FA/gi, 'ú')
    .replace(/%FB/gi, 'û')
    .replace(/%FC/gi, 'ü')
    .replace(/%FD/gi, 'ý')
    .replace(/%FE/gi, 'þ')
    .replace(/%FF/gi, 'ÿ')
}

export const regexLocaleCharacters = /%([C-F][0-9A-F]|7[F-F])/gi
